"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_es5 = require("web-streams-polyfill/polyfill/es5");
var import_text_decoder = require("@bacons/text-decoder");
var import_structured_clone = __toESM(require("@ungap/structured-clone"), 1);
var import_core_asynciterator_polyfill = require("@azure/core-asynciterator-polyfill");
var import_url = require("core-js/actual/url");
var import_url_search_params = require("core-js/actual/url-search-params");
var import_promiseWithResolvers = require("./utils/promiseWithResolvers");
var _globalThis;
var _TextDecoder;
var _globalThis1;
var _structuredClone;
var _globalThis2;
var _requestAnimationFrame;
globalThis["global"] = globalThis;
(_globalThis = globalThis)[_TextDecoder = "TextDecoder"] || (_globalThis[_TextDecoder] = import_text_decoder.TextDecoder);
(_globalThis1 = globalThis)[_structuredClone = "structuredClone"] || (_globalThis1[_structuredClone] = import_structured_clone.default);
(_globalThis2 = globalThis)[_requestAnimationFrame = "requestAnimationFrame"] || (_globalThis2[_requestAnimationFrame] = setTimeout);
Promise.withResolvers || (Promise.withResolvers = import_promiseWithResolvers.promiseWithResolvers);
//# sourceMappingURL=polyfills-mobile.js.map
